<template>
  <div>
    <QueryFrame
      :disablePage="true">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>目录名称:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.AKA061"></lk-input>
          </div>
          <div class="queryItem">
            <label>助记码 :</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.AKA066"></lk-input>
          </div>
          <div class="queryItem">
            <label>生产厂家:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.BKC098"></lk-input>
          </div>
          <div class="queryItem">
            <label>批准文号:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.AKA111"></lk-input>
          </div>
          <div class="queryItem">
            <label>药监局药品编码 :</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.AKA112"></lk-input>
          </div>
          <div class="queryItem">
            <label>当传25时下载特殊药品，不传或传空字符则按上面条件查询 :</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.AKA113"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import insurance from '../../../services/insurance';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';

export default {
  name: 'MedicareCatalogue',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {},
  data() {
    return {
      query: {
        AKA061: null,
        AKA066: null,
        BKC098: null,
        AKA111: null,
        AKA112: null,
        AKA113: null,
      },
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
          // indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        // {
        //   title: '医保编码',
        //   key: 'AKA060',
        //   minWidth: 116,
        // },
        {
          title: '通用名',
          key: 'aka115',
          minWidth: 116,
        },
        {
          title: '通用编码',
          key: 'aka114',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '生产单位',
          key: 'aka111',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '限制数量',
          key: 'aka116',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '批准文号1',
          key: 'aka112',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '批准文号2',
          key: 'aka113',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '自付比例',
          key: 'aka069',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '药品编码',
          key: 'aka060',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '中文名称',
          key: 'aka061',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '英文名称',
          key: 'aka062',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '收费类别',
          key: 'aka063',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '处方药标志',
          key: 'aka064',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '收费项目等级',
          key: 'aka065',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '标准价格',
          key: 'aka068',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '剂型',
          key: 'aka070',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '限制类用药标志',
          key: 'aka215',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '当前有效标志',
          key: 'aae100',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '门诊特殊处理方式',
          key: 'bkc097',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '住院特殊处理方式',
          key: 'bkc098',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '一级目录类别',
          key: 'bka246',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '二级目录类别',
          key: 'bka247',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '三级目录类别',
          key: 'bka260',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '助记码',
          key: 'aka066',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '单位',
          key: 'aka067',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '每次用量',
          key: 'aka071',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '使用频次',
          key: 'aka072',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '用法',
          key: 'aka073',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '规格',
          key: 'aka074',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '备注',
          key: 'aae013',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '经办人',
          key: 'aae011',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '经办日期',
          key: 'aae036',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '所属经办机构',
          key: 'aab034',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '工伤自付比例',
          key: 'bka002',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '工伤收费类别',
          key: 'bka001',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '限制价格',
          key: 'bkc099',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '险种',
          key: 'aae140',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '数据分区',
          key: 'baa001',
          minWidth: 116,
          tooltip: true,
        },
      ],
      tableData: [],
    };
  },
  methods: {
    handleReset() {
      this.query = {};
    },
    getData() {
      // this.params.page = this.page;
      // this.params.size = this.size;
      insurance.medicareCatalogueList(this.params).then((res) => {
        if (res.data.status === 200) {
        	const data = res.data.data;
        	data.forEach((item) => {
        		item.aae036 = utils.formatDate(item.aae036);
          });
          this.tableData = data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
</style>
